exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.placeholder-scene[data-v-57a418f7] { display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 520px; color: #a0a8b8; background: #fff;\n}\n.placeholder-scene i[data-v-57a418f7] { margin-bottom: 14px; font-size: 42px; color: #bfd0ed;\n}\n.placeholder-scene p[data-v-57a418f7] { margin: 0; font-size: 15px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-57a418f7","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/page/simulate/jushuitan/JstErpPlaceholderScene.vue
// module id = 1380
// module chunks = 0